import React, { useEffect, useState, useCallback, useMemo } from 'react';

import { MethodProps } from '../types';
import Microdeb from '~/Components/Microdeb';
import { useI18n, useSelector } from '~Hooks';
import { useStorage } from '~Components/Storage';
import NumberInput from '~ComponentsImproved/Numpad';

const MicrodebPayment: React.FunctionComponent<MethodProps> = ({
  payment,
  discount,
  amount,
  onMetaChange,
  onComplete,
  onFail,
  subtotal,
}) => {
  const [storage] = useStorage();
  const { i18n } = useI18n();
  const [isFailing, setIsFailing] = useState(false);
  const [showTipModal, setShowTipModal] = useState(!payment.disableTip && storage.enableTipping);

  function onFailAndClose() {
    setIsFailing(true);
    onFail();
  }

  if (showTipModal) {
    return (
      <NumberInput
        key="tip"
        initialValue={'0'}
        decimal
        title={i18n('TM.Tip')}
        onSubmit={(tipAmount) => {
          setShowTipModal(false);

          // Ensure input is valid
          const tip = parseFloat(tipAmount);
          if (isNaN(tip)) {
            onFail();
            return;
          }

          // Set amount to total including tip
          onMetaChange({ tip: tip * 100 });

          // Go on to microdeb payment
          // Slight delay so meta has time to update
          setTimeout(() => setShowTipModal(false), 1000);
        }}
        onClose={() => {
          setShowTipModal(false);
          onFail(i18n('Payment.Canceled'));
        }}
      />
    );
  }

  const tip = payment.meta.tip;
  return (
    <Microdeb
      id={payment.id}
      amount={amount! + (tip ?? 0)}
      vat={amount! - subtotal - (tip ?? 0)}
      isFailing={isFailing}
      onFail={onFailAndClose}
      onComplete={(transactionId) =>
        onComplete(null, {
          transactionId,
        })
      }
      type="PAYMENT"
    />
  );
};

export default MicrodebPayment;
